/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { Dispatch, useCallback, useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import HotelDetails from '@customTypes/hotel-details';
import ProductData from '@customTypes/product';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Lazy } from 'swiper';
// import ExploreMoreHotels from '@components/ExploreMoreHotels/ExploreMoreHotels';
import { getNearbyHotels, getNextAvailableDates, getResponseWithUrl } from '@utils/services';
import useSessionStorage from '@hooks/useSessionStorage';
import sessionStorageKeys from '@constants/sessionStorageKeys';
import { getDateWithSlashes, getDetailedDateWithDayOfWeekShort } from '@helpers/date';
import { GroupedDates, NextDaysDataResultsItem } from '@customTypes/next-available-dates';
import Link from 'next/link';
import ImageFallback from '@components/common/Image/ImageFallback';
import StarRating from '@components/common/StarRating';
import Currency from '@components/common/Currrency/Currency';
import useIsMobile from '@hooks/useIsMobile';
import closeWithShadow from '@assets/images/close-with-shadow.svg';
import calendarIconWhite from '@assets/images/calendar-icon-white.svg';
import ButtonSecondaryRoundedCorners from '@components/common/ButtonSecondaryRoundedCorners';
import { NextAvailableHotelItem } from '@customTypes/next-available-hotels';
import {
  dlpNearbyHotelClicked,
  dlpNextAvailableDateClicked,
  dlpNoNextAvailableInventory,
  dlpNoNextAvailableNearByHotels,
} from '@events/DLP';
import styles from './NextAvailable.module.css';

type Props = {
  product: ProductData;
  hotelDetails: HotelDetails;
  confirmedDate: Date | undefined;
  setConfirmedDate: (date: Date | undefined) => void;
  isNextAvailableModalOpen: boolean;
  setIsNextAvailableModalOpen: Dispatch<boolean>;
};
SwiperCore.use([Navigation, Lazy]);

export default function NextAvailable({
  hotelDetails,
  product,
  confirmedDate,
  setConfirmedDate,
  isNextAvailableModalOpen,
  setIsNextAvailableModalOpen,
}: Props) {
  const navigationPrevRef = useRef<HTMLDivElement>(null);
  const navigationNextRef = useRef<HTMLDivElement>(null);
  const navigationPrevHotelRef = useRef<HTMLDivElement>(null);
  const navigationNextHotelRef = useRef<HTMLDivElement>(null);
  const [latestSlideIndex, setLatestSlideIndex] = useState<number>(0);
  const [groupedDates, setGroupedDates] = useState<GroupedDates[]>([]);
  const [unGroupedDates, setUnGroupedDates] = useState<NextDaysDataResultsItem[]>([]);
  const [nearByHotels, setNearByHotels] = useState<NextAvailableHotelItem[]>([]);
  const [nextUrl, setNextUrl] = useState<string>('');
  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(false);
  const [noNearByHotels, setNoNearByHotels] = useState<boolean>(false);
  const [noInventory, setNoInventory] = useState<boolean>(false);
  const { setItem } = useSessionStorage();
  const isMobile = useIsMobile();

  const handleClick = (newhotel: NextAvailableHotelItem) => {
    setIsNextAvailableModalOpen(false);
    dlpNearbyHotelClicked(product, newhotel, confirmedDate);
  };

  const updateGroupDates = useCallback(
    (currentDates: NextDaysDataResultsItem[], nextDates?: NextDaysDataResultsItem[]) => {
      if (nextDates) {
        const currentKey = currentDates[0].inventory_date;
        const nextKey = nextDates[0].inventory_date;
        setUnGroupedDates([...unGroupedDates, ...currentDates, ...nextDates]);
        setGroupedDates([
          ...groupedDates,
          { id: currentKey, dateArray: [...currentDates] },
          { id: nextKey, dateArray: [...nextDates] },
        ]);
      } else {
        const currentKey = currentDates[0].inventory_date;
        setGroupedDates([...groupedDates, { id: currentKey, dateArray: [...currentDates] }]);
        setUnGroupedDates([...unGroupedDates, ...currentDates]);
      }
    },
    [groupedDates, unGroupedDates],
  );

  const updateNearByHotels = useCallback(
    (hotels: any) => {
      setNearByHotels([...nearByHotels, ...hotels]);
    },
    [nearByHotels],
  );

  useEffect(() => {
    (async () => {
      try {
        if (confirmedDate && isNextAvailableModalOpen) {
          const nearByHotelsData = await getNearbyHotels(product.product_id, 0, confirmedDate);
          if (nearByHotelsData.data.results) {
            updateNearByHotels(nearByHotelsData.data.results);
          } else {
            setNoNearByHotels(true);
          }
        }
      } catch (error: any) {
        setNoNearByHotels(true);
        // TODO: Display error message
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmedDate, product.product_id, isNextAvailableModalOpen]);

  useEffect(() => {
    if (noNearByHotels) {
      dlpNoNextAvailableNearByHotels(product, hotelDetails, confirmedDate);
    }
  }, [confirmedDate, hotelDetails, noNearByHotels, product]);

  useEffect(() => {
    if (noInventory) {
      dlpNoNextAvailableInventory(product, hotelDetails, confirmedDate);
    }
  }, [confirmedDate, hotelDetails, noInventory, product]);

  useEffect(() => {
    (async () => {
      try {
        if (confirmedDate && isNextAvailableModalOpen) {
          const availableDates = await getNextAvailableDates(
            product.product_id,
            hotelDetails.metadata.hotel_id,
            0,
            confirmedDate,
          );
          if (
            availableDates.data &&
            availableDates.data.results &&
            availableDates.data.results.length > 0
          ) {
            if (availableDates.data._links && availableDates.data._links._next && !isMobile) {
              const nextAvailableDates = await getResponseWithUrl(availableDates.data._links._next);
              if (
                nextAvailableDates.data &&
                nextAvailableDates.data.results &&
                nextAvailableDates.data.results.length > 0
              ) {
                setNextUrl(nextAvailableDates.data._links._next);
                updateGroupDates(availableDates.data.results, nextAvailableDates.data.results);
                return;
              }
              updateGroupDates(availableDates.data.results);
              setNextUrl(availableDates.data._links._next);
              return;
            }
            updateGroupDates(availableDates.data.results);
            setNextUrl(availableDates.data._links._next);
          } else {
            setNoInventory(true);
          }
        }
      } catch (error: any) {
        setNoInventory(true);
        // TODO: Display error message
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    confirmedDate,
    hotelDetails.metadata.hotel_id,
    product.product_id,
    isNextAvailableModalOpen,
    isMobile,
  ]);

  const onSlideChange = async (swiper: any) => {
    if (swiper.activeIndex > latestSlideIndex && unGroupedDates.length < 60) {
      try {
        const availableDates = await getResponseWithUrl(nextUrl);
        if (
          availableDates.data &&
          availableDates.data.results &&
          availableDates.data.results.length > 0
        ) {
          setNextUrl(availableDates.data._links._next);
          setLatestSlideIndex(swiper.activeIndex);
          updateGroupDates(availableDates.data.results);
        }
      } catch (error) {
        // TODO: Display error message
      }
    }
  };

  const onShowMoreResultsClick = async () => {
    try {
      const availableDates = await getResponseWithUrl(nextUrl);
      if (
        availableDates.data &&
        availableDates.data.results &&
        availableDates.data.results.length > 0
      ) {
        updateGroupDates(availableDates.data.results);
        if (availableDates.data._links) {
          setNextUrl(availableDates.data._links._next);
        } else {
          setNextUrl('');
        }
      } else {
        setNextUrl('');
      }
    } catch (error: any) {
      setNextUrl('');
      // TODO: Display error message
    }
  };

  const closeBottomDrawer = () => {
    setUnGroupedDates([]);
    setGroupedDates([]);
    setIsNextAvailableModalOpen(false);
  };

  const updateConfirmedDate = (date: string) => {
    const dateFormatted = `${date.split('T')[0]}T15:00:00.000Z`;
    if (isMobile) {
      closeBottomDrawer();
    } else {
      setIsNextAvailableModalOpen(false);
    }
    setConfirmedDate(new Date(dateFormatted));
    setItem(
      sessionStorageKeys.SMART_CALENDAR_DATE,
      dateFormatted ? getDateWithSlashes(new Date(dateFormatted)) : '',
    );
    dlpNextAvailableDateClicked(product, hotelDetails, new Date(dateFormatted));
  };

  // Hack to re-render swiper and make the arrows work.
  useEffect(() => {
    if (!isFirstLoad) {
      setTimeout(() => {
        setIsFirstLoad(true);
      }, 3000);
    }
  }, [isFirstLoad]);

  return (
    <div
      className={`flex flex-col next-available d:w-856 overflow-x-hidden ${
        nearByHotels && nearByHotels.length === 0 ? 'pb-4 d:pb-0' : 'pb-0'
      }`}
    >
      {isMobile && (
        <div className="flex pl-5 h-60px justify-start items-center text-15 font-rp-pn-semi-bold w-full rounded-xl z-100 bg-white d:w-96 d:hidden">
          <button
            type="button"
            className="relative flex items-center mt-1.5"
            onClick={closeBottomDrawer}
          >
            <Image src={closeWithShadow} alt="close-button" />
          </button>
        </div>
      )}
      <div className="px-6 flex flex-row flex-wrap text-12 d:text-sm text-rp-gray font-rp-pn-semi-bold opacity-90 tracking-wide pt-2.5 d:pt-0">
        <p className="mr-2">{hotelDetails.name.toUpperCase()}</p>
        <p className="mr-2 -mt-2 text-xl d:-mt-2.5">.</p>
        <p className="">
          {product.product_type.toUpperCase() === 'DAY_PASS'
            ? 'DAY PASS'
            : product.product_type.toUpperCase()}
        </p>
      </div>
      {(groupedDates.length > 0 || unGroupedDates.length > 0) && (
        <p className="px-6 text-21 pt-2 font-rp-pn-semi-bold text-rp-primary-black-medium d:text-28 d:pt-4">
          Next Available Dates
        </p>
      )}
      {!isMobile && groupedDates.length > 0 ? (
        <div className={`${nearByHotels && nearByHotels.length === 0 ? 'pb-4' : 'pb-5'}`}>
          <div className="px-6 hidden d:flex h-9 space-x-2 items-end justify-end -mt-10">
            <div ref={navigationPrevRef} className="swiper-button-prev" />
            <div ref={navigationNextRef} className="swiper-button-next" />
          </div>
          <div className="px-6 flex mt-6 swiper-left pb-3">
            <Swiper
              id="explore-hotels-swiper"
              spaceBetween={20}
              slidesPerView="auto"
              navigation={{
                prevEl: navigationPrevRef.current!,
                nextEl: navigationNextRef.current!,
              }}
              preloadImages
              lazy={{ loadPrevNext: true }}
              initialSlide={0}
              onSlideNextTransitionStart={onSlideChange}
            >
              {groupedDates?.map((dates: GroupedDates) => (
                <SwiperSlide key={dates.id}>
                  <div className="flex flex-row flex-nowrap w-auto d:flex-wrap gap-3">
                    {dates.dateArray.map((date: NextDaysDataResultsItem) => (
                      <button
                        type="button"
                        onClick={() => updateConfirmedDate(date.inventory_date)}
                        className={`w-2/5 text-white rounded-lg py-3 px-6 bg-rp-primary ${
                          groupedDates.length === 1 && groupedDates[0].dateArray.length < 3
                            ? 'd:w-auto'
                            : 'd:w-32%'
                        }`}
                      >
                        <div className="flex flex-row items-center">
                          <Image src={calendarIconWhite} alt="close-button" />
                          <p className="pl-2.5">{date.inventory_date_plain}</p>
                        </div>
                      </button>
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      ) : unGroupedDates.length > 0 && isMobile ? (
        <div className="flex flex-row flex-nowrap w-full overflow-auto gap-3 pt-4 px-6 h-24 shadow-showNextAvailable mb-1">
          {unGroupedDates.map((date: NextDaysDataResultsItem) => (
            <button
              type="button"
              onClick={() => updateConfirmedDate(date.inventory_date)}
              className="flex-shrink-0 h-14 text-white rounded-lg py-3 px-6 bg-rp-primary"
            >
              <div className="flex flex-row items-center">
                <Image src={calendarIconWhite} alt="close-button" />
                <p className="pl-2.5">{date.inventory_date_plain}</p>
              </div>
            </button>
          ))}
          {isMobile && (
            <div className="w-32 h-14 flex-shrink-0 mr-1">
              <ButtonSecondaryRoundedCorners
                onClick={onShowMoreResultsClick}
                isDisabled={nextUrl === ''}
                classes="underline"
              >
                Show More
              </ButtonSecondaryRoundedCorners>
            </div>
          )}
        </div>
      ) : (
        <div
          className={`px-6 mt-2 shadow-showNextAvailable mb-1 ${
            nearByHotels && nearByHotels.length === 0 ? 'pb-10' : 'pb-4'
          }`}
        >
          <p
            className={`text-rp-gray opacity-90 border-t border-rp-gray-divider ${
              nearByHotels && nearByHotels.length === 0 ? 'pt-4 d:pt-6' : 'pt-4'
            }`}
          >
            Unfortunately, there’s currently no future availability for this hotel.
          </p>
        </div>
      )}
      {nearByHotels && nearByHotels.length > 0 && (isFirstLoad || !isFirstLoad) && (
        <div className="px-6 pt-5 bg-rp-light-background pb-8 rounded-b-lg overflow-x-hidden d:pt-6">
          {confirmedDate && (
            <>
              <p className="hidden text-xl font-rp-pn-semi-bold text-rp-primary-black d:block">
                {`These hotels have availability on ${getDetailedDateWithDayOfWeekShort(
                  confirmedDate,
                )}`}
              </p>
              <div className="flex flex-col d:hidden">
                <p className="text-rp-gray opacity-90 capitalize pb-2">
                  {getDetailedDateWithDayOfWeekShort(confirmedDate, true)}
                </p>
                <p className="text-xl font-rp-pn-semi-bold text-rp-primary-black">
                  These hotels have availability nearby
                </p>
              </div>
            </>
          )}
          {nearByHotels && nearByHotels.length > 3 && (
            <div className="hidden d:flex h-9 space-x-2 items-end justify-end -mt-9 d:w-full">
              <div ref={navigationPrevHotelRef} className="swiper-button-prev" />
              <div ref={navigationNextHotelRef} className="swiper-button-next" />
            </div>
          )}
          <div className="flex mt-6 swiper-left">
            <Swiper
              id="explore-hotels-swiper"
              spaceBetween={20}
              slidesPerView="auto"
              navigation={{
                prevEl: navigationPrevHotelRef.current!,
                nextEl: navigationNextHotelRef.current!,
              }}
              preloadImages
              lazy={false}
              initialSlide={0}
              loop={nearByHotels.length > 3}
            >
              {nearByHotels?.map((hotel: NextAvailableHotelItem) => (
                <SwiperSlide key={hotel.hotel_id} className={styles.fixedWidth}>
                  <Link href={hotel.url}>
                    <a
                      role="link"
                      tabIndex={0}
                      onKeyDown={() => {
                        handleClick(hotel);
                      }}
                      onClick={() => {
                        handleClick(hotel);
                      }}
                    >
                      <div className="flex flex-col">
                        <div className={styles.imageFixedSize}>
                          <ImageFallback
                            className="rounded-xl"
                            layout="fill"
                            objectFit="cover"
                            src={hotel.desktop_image}
                            alt={hotel.hotel_name}
                            loading="lazy"
                          />
                        </div>

                        <div className="flex flex-col mt-3.5 space-y-1">
                          <p className="font-rp-pn-semi-bold truncate">{hotel.hotel_name}</p>
                          <div className="flex font-rp-pn-regular items-center text-rp-dark-gray text-sm">
                            {hotel.avg_rating ? (
                              <>
                                <StarRating rating={`${hotel.avg_rating}`} size="4" />
                                <p className="-ml-1 pl-2">{hotel.avg_rating}</p>
                              </>
                            ) : null}

                            {hotel.num_reviews && Number(hotel.num_reviews) > 0 && (
                              <>
                                <div className="pl-1 -mt-3 text-2xl">.</div>
                                <p className="pl-1">{`${hotel.num_reviews} reviews`}</p>
                              </>
                            )}
                          </div>
                          <div className="flex">
                            <p className="text-11 tracking-wide">
                              {hotel.product_type.toUpperCase()}
                            </p>
                            <div className="bg-rp-green-3 flex items-center justify-center rounded-xl h-5 w-20 text-11 text-rp-green-4 mt-0.5 ml-3 tracking-0.3 d:ml-2">
                              AVAILABLE
                            </div>
                          </div>
                          <div style={{ marginTop: '0' }}>
                            <Currency
                              value={hotel.best_price}
                              valueClasses="text-xl font-rp-pn-semi-bold"
                              isoCodeClasses="text-xl"
                            />
                          </div>
                        </div>
                      </div>
                    </a>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
}
